export var StatusMessageTypes;
(function (StatusMessageTypes) {
    StatusMessageTypes["MicrophonePermissionNotGranted"] = "microphone permission not granted";
    StatusMessageTypes["CannotRecordOnThisPhone"] = "cannot record on this phone";
    StatusMessageTypes["RecordingFailed"] = "recording failed";
    StatusMessageTypes["NoRecordingInProgress"] = "no recording in progress";
    StatusMessageTypes["FailedToFetchRecording"] = "failed to fetch recording";
    StatusMessageTypes["RecordingInProgress"] = "recording in progress";
    StatusMessageTypes["MicrophoneIsBusy"] = "microphone is busy";
    StatusMessageTypes["RecordingStared"] = "recording stared";
})(StatusMessageTypes || (StatusMessageTypes = {}));
//# sourceMappingURL=status-message-types.js.map